'use client';

import { Fieldset } from '@chakra-ui/react';

import { useFormError } from '../../../hooks';
import type { FormFieldsetProps, FormValues } from '../../../types';

export const FormFieldset = <T extends FormValues>(props: FormFieldsetProps<T>) => {
	const {
		children, helperText, label, name, ...rest
	} = props;
	const { errorText, isError, isSubmitting } = useFormError(name);
	const Component = isError ? Fieldset.ErrorText : Fieldset.HelperText;
	const text = isError ? errorText : helperText;

	return (
		<Fieldset.Root disabled={isSubmitting} invalid={isError} {...rest}>
			{label && (
				<Fieldset.Legend>
					{label}
				</Fieldset.Legend>
			)}
			{children}
			{text && (
				<Component minH="14px" ml={1} textStyle="caption">
					{text}
				</Component>
			)}
		</Fieldset.Root>
	);
};
